import React from "react"
import TextField from "material-ui/TextField"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import Toggle from "material-ui/Toggle"
import AuthenticationStore from "../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import PayrollSelection from "../../components/payroll/PayrollSelection"
import HierarchyItemChip from "../../components/hierarchy/HierarchyItemChip"
import autobind from "class-autobind"
import * as userActions from "../../actions/UserActions"
import * as utils from "../../helpers/utils"
import { IUserDocument, IUserDataHint, IJobDocument, IJobPhase, IUIUser, ELanguage, ESuepervisorJobExplicitTypes } from "../../models"
import MultiSupervisorChips from "../../components/supervisor/MultiSupervisorChips"
import * as userHelper from "../../helpers/userHelper"
import ChooseHierarchyJobPhaseChipForPunch from "../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import * as permissionHelper from "../../helpers/permissionHelper"
import EmpNewPositions_DefaultPositionSelector from "../../components/position/employee_new_positions/EmpNewPositions_DefaultPositionSelector"
import LanguageSelector from "../../components/language/LanguageSelector"
import * as api from "../../api"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

interface IProps {
	handleAdd(user: IUserDocument): void
	handleClose(): void
}
interface IState {
	firstName: string
	lastName: string
	externalId: string
	clockPin: string
	firstNameErrorText: string
	lastNameErrorText: string
	externalIdErrorText: string
	clockPinErrorText: string
	saveClicked: boolean
	showI9Workflow: boolean
	disableSaveButtons: boolean
	disableCancelButton: boolean
	cellPhone?: string
	address1?: string
	address2?: string
	city?: string
	state?: string
	zip?: string
	userHint?: IUserDataHint
	cellPhoneErrorText?: string
	selectedSupervisorIds: string[]
	defaultPunchHierarchyId: string
	errorDefaultPunchHierarchyId?: string
	defaultPunchJob: IJobDocument
	defaultPunchPhase: IJobPhase
	scheduleRanking: number
	fullTime: boolean
	agency: boolean
	language: ELanguage
}

export default class AddUserDialog extends React.Component<IProps, IState> {
	private ChooseHierarchyJobPhaseChipForPunch
	private EmpNewPositions_DefaultPositionSelector
	private defaultHierarchyItemId = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
	private defaultSelectedSupervisorIds = AccountStore.getSupervisorDirectReportEnabled() ?
		!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees) ?
			[AuthenticationStore.getLoggedInUser().Id] :
			[] :
		[]
	constructor(props) {
		super(props)
		this.state = {
			firstName: "",
			lastName: "",
			externalId: "",
			clockPin: "",
			firstNameErrorText: "",
			lastNameErrorText: "",
			externalIdErrorText: "",
			clockPinErrorText: "",
			saveClicked: false,
			showI9Workflow: true,
			disableSaveButtons: false,
			disableCancelButton: false,
			selectedSupervisorIds: this.defaultSelectedSupervisorIds,
			defaultPunchHierarchyId: this.defaultHierarchyItemId,
			defaultPunchJob: null,
			defaultPunchPhase: null,
			scheduleRanking: 0,
			fullTime: false,
			agency: false,
			language: ELanguage.English
		}
		autobind(this)
	}

	componentDidMount() {
		const loggedInUser = AuthenticationStore.getLoggedInUser()
		if (loggedInUser.JobExplicitTypes === ESuepervisorJobExplicitTypes.Include && loggedInUser.ExplicitJobIds.length == 1) {
			api.getJob(loggedInUser.ExplicitJobIds[0]).then(res => {
				const job: IJobDocument = res.data
				hierarchyHelper.getHierarchyItemsAndChildrensIds([this.defaultHierarchyItemId]).includes(job.HierarchyId) &&
					this.setState({
						defaultPunchHierarchyId: job.HierarchyId,
						defaultPunchJob: job,
						defaultPunchPhase: null
					})
			})
		}
	}

	handleCellPhoneChange(e) {
		const _this = this
		this.setState({
			cellPhone: e.target.value.replace(/\D/g, "")
		}, () => {
			if (utils.validatePhone(this.state.cellPhone)) {
				userActions.getUserHint(this.state.cellPhone).then(res => {
					const userHint = res.data
					_this.setState({
						firstName: userHint.FirstName,
						lastName: userHint.LastName,
						address1: userHint.Street1,
						address2: userHint.Street2,
						city: userHint.City,
						state: userHint.State,
						zip: userHint.Zipcode,
						userHint: userHint
					})
				})
			} else {
				_this.setState({
					firstName: "",
					lastName: "",
					address1: "",
					address2: "",
					city: "",
					state: "",
					zip: ""
				})
			}
		})
	}

	handleExternalIdChange(e) {
		this.setState({ externalId: e.target.value }, () => this.state.saveClicked && this.validateForm())
	}

	handleClockPinChange(e) {
		this.setState({ clockPin: e.target.value.replace(/\D/g, "") }, () => this.state.saveClicked && this.validateForm())
	}

	detectEnter(e) {
		e.keyCode === 13 && this.handleRequestSave()
	}

	getUser() {
		const payrollSelection: any = this.refs.PayrollSelection

		const user: IUserDocument = {
			Id: utils.guid(),
			AccountId: AccountStore.getCurrentAccount().Id,
			FirstName: this.state.firstName.trim(),
			LastName: this.state.lastName.trim(),
			ExternalId: this.state.externalId.trim(),
			ClockPin: this.state.clockPin.trim(),
			DefaultHierarchyItemId: this.defaultHierarchyItemId,
			DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
			DefaultJobId: this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null,
			DefaultJobName: this.state.defaultPunchJob ? this.state.defaultPunchJob.Name : null,
			DefaultPhaseId: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null,
			DefaultPhaseName: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Name : null,
			DefaultPositionId: this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId ? this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId : null,
			Positions: this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions && this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions.length > 0 ?
				this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions : [],
			PayrollHierarchyItemId: AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollHierarchyItem.Id : null,
			PayrollPayGroupId: AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollPayGroupId : null,
			OTPolicyId: AccountStore.getEnableOTPolicy() && payrollSelection.state.otPolicyManualSet ?
				payrollSelection.state.otPolicyId :
				null,
			SupervisorIds: this.state.selectedSupervisorIds.length ? this.state.selectedSupervisorIds : null,
			ScheduleWeight: AccountStore.getScheduleEnabled() ? this.state.scheduleRanking : null,
			Agency: this.state.agency,
			Float: false,
			PerDiem: false,
			FullTime: this.state.fullTime,
			Language: this.state.language
		}

		if (AccountStore.getExplicitEmployeeHierarchyAssignment()) {
			user.LinkedHierarchyIds = [this.defaultHierarchyItemId]
		}

		if (AccountStore.getI9Enabled()) {
			user.AssignedAccountUserId = AuthenticationStore.getLoggedInUser().Id
			user.I9Status = {
				EnableI9Workflow: true,
				UserDataHint: this.state.userHint,
				Status: 0,
				HireNotification: null,
				Section1Started: null,
				Section1Complete: null,
				MeetingNotification: null,
				Section2Started: null,
				Section2Complete: null
			}
			user.Address = {
				MobilePhone: this.state.cellPhone
			}
		}
		return user
	}

	handleRequestSave() {
		this.setState({ disableSaveButtons: true })
		this.validateForm().then(res => {
			if (res) {
				this.setState({ disableCancelButton: true })
				this.props.handleAdd(this.getUser())
				this.props.handleClose()
			} else {
				this.setState({ disableSaveButtons: false })
			}
		})
		this.setState({ saveClicked: true })
	}

	handleRequestAddAnother() {
		this.setState({ disableSaveButtons: true })
		this.validateForm().then(res => {
			if (res) {
				this.props.handleAdd(this.getUser())
				this.EmpNewPositions_DefaultPositionSelector.setState({
					defaultPositionId: null,
					errorDefaultPositionId: null,
					newEmpPositions: [],
					defaultPositionCandidates: []
				}, () =>
					this.setState({
						disableSaveButtons: false,
						firstName: "",
						lastName: "",
						externalId: "",
						clockPinErrorText: "",
						clockPin: "",
						saveClicked: false,
						selectedSupervisorIds: this.defaultSelectedSupervisorIds,
						defaultPunchHierarchyId: this.defaultHierarchyItemId,
						defaultPunchJob: null,
						defaultPunchPhase: null,
						scheduleRanking: 0,
						fullTime: false,
						agency: false,
						language: ELanguage.English
					})
				)
			} else {
				this.setState({
					saveClicked: true,
					disableSaveButtons: false
				})
			}
		})
	}

	validateForm() {
		let returnVal = true

		if (!this.state.firstName.trim()) {
			this.setState({ firstNameErrorText: strings.First_Name_cannot_be_empty })
			returnVal = false
		}
		else if (this.state.firstName.length > 60) {
			this.setState({ firstNameErrorText: strings.formatString(strings.it_cannot_be_longer_than_x_chars, 60) as string })
			returnVal = false
		}
		else if (!utils.validateName(this.state.firstName)) {
			this.setState({ firstNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			returnVal = false
		}
		else {
			this.setState({ firstNameErrorText: "" })
		}

		if (!this.state.lastName.trim()) {
			this.setState({ lastNameErrorText: strings.Last_Name_cannot_be_empty })
			returnVal = false
		}
		else if (this.state.lastName.length > 60) {
			this.setState({ lastNameErrorText: strings.formatString(strings.it_cannot_be_longer_than_x_chars, 60) as string })
			returnVal = false
		}
		else if (!utils.validateName(this.state.lastName)) {
			this.setState({ lastNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			returnVal = false
		}
		else {
			this.setState({ lastNameErrorText: "" })
		}

		if (!AccountStore.getExplicitEmployeeHierarchyAssignment()) {
			if (!userHelper.getEmployeeValidationForDefaultAndPunch(this.defaultHierarchyItemId, this.state.defaultPunchHierarchyId)) {
				this.setState({ errorDefaultPunchHierarchyId: strings.Default_cannot_be_outside_the_Punch_Permission_Hierarchy })
				returnVal = false
			}
			else {
				this.setState({ errorDefaultPunchHierarchyId: "" })
			}
		}

		if (this.ChooseHierarchyJobPhaseChipForPunch && this.ChooseHierarchyJobPhaseChipForPunch.state.errorHierarchyItemId) {
			returnVal = false
		}

		if (this.EmpNewPositions_DefaultPositionSelector.state.errorDefaultPositionId) {
			returnVal = false
		}

		if (AccountStore.getEnableOTPolicy()) {
			const payrollSelection: any = this.refs.PayrollSelection
			if (payrollSelection && payrollSelection.state.errorEmployeeOTPolicyId) {
				returnVal = false
			}
		}

		this.setState({ clockPinErrorText: "" })

		if (!this.state.externalId.trim()) {
			returnVal = false
			this.setState({ externalIdErrorText: (!this.state.externalId.trim() && strings.Employee_ID_cannot_be_empty) || this.state.externalIdErrorText })
			return new Promise((fulfill, reject) => {
				fulfill(returnVal)
			})
		}

		const _this = this
		const accId = AccountStore.getCurrentAccount().Id
		return userActions.externalIdExists(accId, this.state.externalId).then(res => {
			if (res.data) {
				_this.setState({ externalIdErrorText: strings.Employee_ID_must_be_unique })
				returnVal = false
			}
			else {
				_this.setState({ externalIdErrorText: "" })
			}
			return userActions.clockPinExists(accId, this.state.clockPin).then(result => {
				if (result.data) {
					_this.setState({ clockPinErrorText: strings.Clock_PIN_must_be_unique })
					returnVal = false
				}
				return returnVal
			})
		})
	}

	render() {
		return (
			<Dialog
				actionsContainerClassName="AddUserDialog"
				open
				autoScrollBodyContent
				title={strings.ADD_EMPLOYEE}
				actions={[
					<FlatButton
						data-intercom-target={"menu-Employees-Add-Btn-AddAnother"}
						label={strings.Add_Another}
						primary
						style={{ float: "left" }}
						labelStyle={{ textDecoration: "underline" }}
						onTouchTap={this.handleRequestAddAnother}
						disabled={this.state.disableSaveButtons}
					/>,
					<FlatButton
						data-intercom-target={"menu-Employees-Add-Btn-Close-Add-Employee-Dialog"}
						label={strings.CANCEL}
						secondary
						onTouchTap={this.props.handleClose}
						disabled={this.state.disableCancelButton}
					/>,
					<FlatButton
						data-intercom-target={"menu-Employees-Add-Btn-Save-Employee"}
						label={strings.ADD_EMPLOYEE}
						primary
						onTouchTap={this.handleRequestSave}
						disabled={this.state.disableSaveButtons}
					/>
				]}
			>
				{AccountStore.getI9Enabled() &&
					<div>
						<Toggle
							data-intercom-target={"menu-Employees-Add-Toggle-HireUsingI9Workflow"}
							label="Hire using I9 workflow"
							defaultToggled
							toggled={this.state.showI9Workflow}
							onToggle={() => this.setState({ showI9Workflow: !this.state.showI9Workflow })}
							labelPosition="right"
						/>
						{this.state.showI9Workflow &&
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "45%", marginRight: 30, marginTop: 20 }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-CellPhoneNumber"}
									autoFocus={this.state.showI9Workflow}
									floatingLabelText="Cell Phone Number"
									value={this.state.cellPhone}
									onChange={this.handleCellPhoneChange}
									onKeyUp={this.detectEnter}
									errorText={this.state.cellPhoneErrorText}
									style={{ width: "100%" }}
								/>
							</div>
						}
					</div>
				}
				<div style={{ width: "100%" }}>
					<div style={{ height: 60, verticalAlign: "top", marginRight: 45, marginBottom: 10 }}					>
						<TextField
							data-intercom-target={"menu-Employees-Add-Entry-FistName"}
							autoFocus={!AccountStore.getI9Enabled() && this.state.showI9Workflow}
							floatingLabelText="First Name"
							value={this.state.firstName}
							onChange={e => this.setState({ firstName: e.target.value }, () => this.state.saveClicked && this.validateForm())}
							onKeyUp={this.detectEnter}
							errorText={this.state.firstNameErrorText}
							style={{ width: "100%" }}
						/>
					</div>
					<div style={{ height: 60, verticalAlign: "top", marginRight: 45, marginBottom: 10 }}>
						<TextField
							data-intercom-target={"menu-Employees-Add-Entry-LastName"}
							floatingLabelText="Last Name"
							value={this.state.lastName}
							onChange={e => this.setState({ lastName: e.target.value }, () => this.state.saveClicked && this.validateForm())}
							onKeyUp={this.detectEnter}
							errorText={this.state.lastNameErrorText}
							style={{ width: "100%" }}
						/>
					</div>
				</div>
				{AccountStore.getI9Enabled() && this.state.showI9Workflow &&
					<div>
						<div style={{ width: "100%" }}>
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "45%", marginRight: 30 }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-Address1"}
									floatingLabelText="Address 1"
									value={this.state.address1}
									onChange={this.handleExternalIdChange}
									onKeyUp={this.detectEnter}
									errorText={this.state.externalIdErrorText}
									style={{ width: "100%" }}
									maxLength="15"
								/>
							</div>
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "45%" }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-Address2"}
									floatingLabelText="Address2"
									value={this.state.address2}
									onChange={this.handleClockPinChange}
									errorText={this.state.clockPinErrorText}
									onKeyUp={this.detectEnter}
									style={{ width: "100%" }}
									maxLength="15"
								/>
							</div>
						</div>
						<div style={{ width: "100%" }}>
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "40%", marginRight: 30 }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-City"}
									floatingLabelText="City"
									value={this.state.city}
									onChange={this.handleExternalIdChange}
									onKeyUp={this.detectEnter}
									errorText={this.state.externalIdErrorText}
									style={{ width: "100%" }}
									maxLength="15"
								/>
							</div>
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "10%", marginRight: 30 }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-State"}
									floatingLabelText="State"
									value={this.state.state}
									onChange={this.handleClockPinChange}
									errorText={this.state.clockPinErrorText}
									onKeyUp={this.detectEnter}
									style={{ width: "100%" }}
									maxLength="15"
								/>
							</div>
							<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "40%" }}>
								<TextField
									data-intercom-target={"menu-Employees-Add-Entry-Zip"}
									floatingLabelText="Zip"
									value={this.state.zip}
									onChange={this.handleClockPinChange}
									errorText={this.state.clockPinErrorText}
									onKeyUp={this.detectEnter}
									style={{ width: "100%" }}
									maxLength="15"
								/>
							</div>
						</div>
					</div>
				}
				<div>
					<div style={{ width: "100%" }}>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "45%", marginRight: 30 }}>
							<TextField
								data-intercom-target={"menu-Employees-Add-Entry-ExternalId"}
								floatingLabelText={strings.Employee_ID}
								value={this.state.externalId}
								onChange={this.handleExternalIdChange}
								onKeyUp={this.detectEnter}
								errorText={this.state.externalIdErrorText}
								style={{ width: "100%" }}
								maxLength="15"
							/>
						</div>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "45%" }}>
							<TextField
								data-intercom-target={"menu-Employees-Add-Entry-ClockPin"}
								floatingLabelText={strings.Clock_PIN}
								value={this.state.clockPin}
								onChange={this.handleClockPinChange}
								errorText={this.state.clockPinErrorText}
								onKeyUp={this.detectEnter}
								style={{ width: "100%" }}
								maxLength="10"
							/>
						</div>
					</div>
				</div>
				<div style={{ marginTop: 20 }}>
					<HierarchyItemChip
						title={strings.Punch_Permission_Hierarchy}
						hierarchyItemId={this.defaultHierarchyItemId}
					/>
				</div>
				{!AccountStore.getExplicitEmployeeHierarchyAssignment() &&
					<div style={{ marginTop: 20 }}>
						<ChooseHierarchyJobPhaseChipForPunch
							ref={item => this.ChooseHierarchyJobPhaseChipForPunch = item}
							hideIcon
							ignoreNotAllowPunchSetting
							hierarchyChipLabel={strings.Default_Hierarchy}
							jobChipLabel={ checkJobFieldAvailable("singular") ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Default_Job}
							phaseChipLabel={ checkPhaseFieldAvailable("singular") ?  `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}`: strings.Default_Phase}
							employee={{ DefaultHierarchyItemId: this.defaultHierarchyItemId } as IUIUser}
							punchHierarchyItemId={this.state.defaultPunchHierarchyId}
							jobId={this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null}
							phaseId={this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null}
							errorHierarchyChipText={this.state.errorDefaultPunchHierarchyId}
							handleSelectHierarchyJobPhase={(hierarchyItemId, errorHierarchyItemId, job, phase) =>
								this.setState({
									defaultPunchHierarchyId: hierarchyItemId,
									defaultPunchJob: job,
									defaultPunchPhase: phase
								}, () => {
									this.state.saveClicked && this.validateForm()
								})
							}
						/>
					</div>
				}
				{AccountStore.getTimecardEnabled() &&
					<div data-intercom-target={"menu-Employees-Add-Select-Payroll-Hierarchy"}>
						<PayrollSelection
							ref="PayrollSelection"
							width={"45%"}
							employeeDefaultJob={this.state.defaultPunchJob}
							employeeDefaultPunchHierarchyItemId={this.state.defaultPunchHierarchyId}
						/>
					</div>
				}
				<div style={{ display: "flex", marginTop: 10 }}>
					{AccountStore.getSupervisorDirectReportEnabled() &&
						<div style={{ flex: 1 }}>
							<MultiSupervisorChips
								selectedSupervisorIds={this.state.selectedSupervisorIds}
								canChooseYourSelf
								readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees)}
								handleChange={selectedSupervisors => this.setState({ selectedSupervisorIds: selectedSupervisors.map(i => i.Id) })}
								employeePermissionHierarchy={this.defaultHierarchyItemId}
							/>
						</div>
					}
					<div style={{ flex: 1 }}>
						<Toggle
							data-intercom-target={`Add-Employee-${strings.User_Information.split(" ").join("-")}-Toggle-Exempt`}
							label={strings.Exempt}
							onToggle={() => this.setState({ fullTime: !this.state.fullTime })}
							defaultToggled={this.state.fullTime}
							style={{ width: 250 }}
						/>
						<Toggle
							data-intercom-target={`Add-Employees-${strings.User_Information.split(" ").join("-")}-Toggle-Agency`}
							label={strings.User_Agency}
							onToggle={() => this.setState({ agency: !this.state.agency })}
							defaultToggled={this.state.agency}
							style={{ width: 250 }}
						/>
					</div>
				</div>
				<LanguageSelector
					selectedLanguage={this.state.language}
					handleChange={language => this.setState({ language })}
				/>
				{AccountStore.getScheduleEnabled() &&
					permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) &&
					<TextField
						data-intercom-target={"menu-Employees-Add-Entry-ScheduleRanking"}
						floatingLabelText={strings.Schedule_Ranking}
						value={this.state.scheduleRanking}
						onChange={e => utils.validateInteger(e.target.value) && this.setState({ scheduleRanking: Number(e.target.value) })}
						style={{ display: "block" }}
					/>
				}
				<EmpNewPositions_DefaultPositionSelector
					ref={item => this.EmpNewPositions_DefaultPositionSelector = item}
					saveClicked={this.state.saveClicked}
					defaultPunchHierarchyId={this.state.defaultPunchHierarchyId}
					defaultPunchJobId={this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null}
					defaultPunchPhaseId={this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null}
					userPayrollData={{
						Id: null,
						PayrollHierarchyItemId: this.refs.PayrollSelection && (this.refs.PayrollSelection as any).state.employeePayrollHierarchyItem.Id,
						DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
						DefaultJobId: this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null,
						PayrollPayGroupId: this.refs.PayrollSelection && (this.refs.PayrollSelection as any).state.employeePayrollPayGroupId
					}}
					defaultJob={this.state.defaultPunchJob}
				/>
			</Dialog>
		)
	}
}
